<template>
  <div class="navigation-wrap">
    <div class="list-img-box" v-for="(item, i) in listData" :key="i">
      <div class="list-flex">
        <div class="less-than-four-content">
          <div class="user-content">
            <div class="user-content_div" @click="toDetails(item)" v-if="item.media.length==0">
              <div class="head-image-box">
                <img :src="item.avatar_url" />
              </div>
              <div class="user-content-bottom">
                <p>{{ item.nickname }}<!-- <el-tag style="margin-left:10px;" type="warning" effect="plain" size="mini">官方认证</el-tag> --></p>
                <p>{{ item.create_time }}</p>
              </div>
              <div id="follow-hover-btn-box">
                <!-- <div class="follow-btn">关注</div> -->
              </div>
            </div>
            <div class="page-detail-card media_content" v-if="item.media.length>0" style="text-align:left;">
              <div class="imgk mediak" v-for="(media, i) in item.media" :key="i" v-if="i<4"  @click="toDetails(item)">
                <img :src="media.cover" width="100%" alt="">
                <span class="iconfont icon-shipin"></span>
              </div>
              <p style="line-height:25px; margin:10px 0px;">
              <h4 style="font-size:14px;font-weight:500; color:#18252c;">{{item.content}}</h4>
              <div class="user-content_div">
                <div class="head-image-box">
                  <img :src="item.avatar_url" />
                </div>
                <div class="user-content-bottom">
                  <p>{{ item.nickname }}</p>
                  <p>{{ item.create_time }}</p>
                </div>
                <div id="follow-hover-btn-box">
                  <!-- <div class="follow-btn">关注</div> -->
                </div>
              </div>
              </p>
              <div style="clear:both"></div>
            </div>
            <div class="page-detail-card" v-else style="text-align:left;">
              <p style="line-height:25px; margin:10px 0px;" @click="toDetails(item)">{{ item.content }}</p>
              <div class="img_box" @click="toDetails(item)">
                <div class="imgk" v-for="(img, i) in item.image" :key="i" v-if="i<4">
                  <img :src="img.url" alt="">
                  <span @click="toDetails(item)" class="addMan" v-if="item.image.length > 4">+{{
                                  item.image ? item.image.length :
                                    ''
                              }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="college-tag" v-if="item.tag">
        <div v-for="(tag, t) in item.tag" :key="t">{{ tag }}</div>
      </div>
      <div class="img-tag">
        <div class="type-tag">
          {{ item.type == 1?'动态':item.type==3?'作业':'作品' }}
        </div>
        <div class="img-tag-right">
          <div class="comment-box" @click="toDetails(item)">
            <span class="iconfont icon-pingjia"></span>
            <span>{{ item.comment_num }}</span>
          </div>
          <div class="praise-box" :class="item.is_like == true?'is_true':''" @click.stop="likeClick(i)">
            <span class="iconfont icon-zan"></span>
            <span>{{ item.like_num }}</span>
          </div>
          <div class="collect-box" :class="item.is_collect == true?'is_true':''" @click.stop="collectClick(i)">
            <span class="iconfont icon-shoucang"></span>
            <span>{{ item.is_collect == true?'已收藏':'未收藏' }}</span>
          </div>
        </div>
      </div>
      <div class="fenxiang" v-if="item.fenxShow">
        <div class="pop__box"><span class="pop__slogan">分享给朋友看看吧：</span>
          <ul class="pop__icons">
            <li title="分享至微信" class="icons_wechat">
              <div class="wechat__qrcode wechat__qrcode_hor"><img
                  src="data:image/jpeg;base64,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">
                <p>微信扫一扫</p>
              </div>
            </li>
            <li title="分享至QQ" class="icons_qq">
            </li>
            <li title="分享至Qzone" class="icons_qzone">
            </li>
            <li title="分享至微博" class="icons_weibo">
            </li>
          </ul>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'Post',
    props: ['listData'],
    data() {
      return {

      }
    },
    created() {

    },
    methods: {
      toDetails(item) {
        this.$router.push({
          path: "/CircleDetails",
          query: {
            id: item.id,
            type_id: item.type_id,
            type: item.type
          }
        })
      },
      likeClick(index) {
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/user/likeThis', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token'),
          },
          data: {
            type: 1,
            type_id: this.listData[index].id
          }
        }).then(res => {
          if (res.data.code == 200) {
            var status = this.listData[index].is_like;
            this.listData[index].is_like = !status
            if (status == true) {
              this.listData[index].like_num -= 1
            } else {
              this.listData[index].like_num += 1
            }
          }
        })
      },
      collectClick(index) {
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/user/collectThis', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token'),
          },
          data: {
            type: 1,
            type_id: this.listData[index].id
          }
        }).then(res => {
          if (res.data.code == 200) {
            var status = this.listData[index].is_collect;
            this.listData[index].is_collect = !status
          }
        })
      }
    }
  }
</script>
<style scoped>

  .media_content .mediak {
     margin-right:15px;
  }
  .media_content .user-content_div {
    position:absolute;
    bottom:10px;
    left:200px;
  }

  .is_true .icon-shoucang {
    color: #FABE00
  }

  .is_true .icon-zan {
    color: #FD6D64
  }

  p {
    color: #18252c;
  }

  .page-content {
    line-height: 25px;
    margin: 10px 0;
  }

  .img_box {
    display: flex;
    overflow: hidden;
    width: 100%;
    position: relative;
  }

  .mediak {
    float: left;
  }

  .imgk {
    width: 185px;
    height: 130px;
    margin-right: 10px;
    margin-bottom: 10px;
    border-radius: 10px;
    cursor: pointer;
    overflow: hidden;

    &:last-child {
      margin-right: 0;
    }
  }

  .imgk .iconfont {
    position: absolute;
    left: 70px;
    top: 30px;
    font-size: 50px;
    color: white;
  }

  .imgk img {
    width: 100%;
    position: relative;
  }

  .addMan {
    position: absolute;
    bottom: 18px;
    cursor: pointer;
    right: 16px;
    width: 41px;
    height: 28px;
    background: #000;
    border-radius: 17px;
    opacity: .6;
    text-align: center;
    line-height: 28px;
    font-weight: 600;
    color: #fff;
  }

  .user-content_div {
    display: flex;
  }

  .user-comment {
    height: 25px;
  }

  .circle {
    padding-top: 30px;
    margin: 0px;
    width: 1190px;
    padding-left: 10px;
    margin: 0 auto;
  }

  .circle-center {
    width: 780px;
    margin-left: 125px;
  }

  .slider-item img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
  }

  .list-img-box {
    margin-top: 31px;
    margin-bottom: 20px;
  }

  .less-than-four-content {
    flex: 1;
    margin-left: 12px;
    position: relative;
    cursor: pointer;
  }

  .img-tag {
    display: flex;
    justify-content: flex-start;
    position: relative;
    margin-top: 12px;
  }

  .college-tag {
    margin-top: 20px;
    width: 100%;
    height: 28px;
  }

  .college-tag div {
    padding: 0 9px;
    float: left;
    height: 24px;
    background: oldlace;
    border-radius: 12px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 400;
    color: #FABE00;
    line-height: 24px;
    text-align: center;
    cursor: auto;
    margin-right: 5px;
  }


  .type-tag {
    padding: 0 9px;
    height: 24px;
    background: #f7f7f7;
    border-radius: 12px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 400;
    color: #465156;
    line-height: 24px;
    text-align: center;
    cursor: auto;
  }

  .college-tag-courseType {
    margin-left: 8px;
  }

  .img-tag-right {
    display: flex;
    margin-left: auto;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 500;
    color: #747c80;
  }

  .img-tag-right .iconfont {
    margin-right: 8px;
    font-size: 23px;
  }

  .collect-box {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .collect-box img {
    width: 24px;
    vertical-align: text-bottom;
    margin-right: 4px;
  }

  .collect-box span {
    font-family: PingFangSC-Medium, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-size: 12px;
    font-weight: 500;
    color: #747c80;
  }

  .line {
    width: 100%;
    height: 1px;
    background: #e6e6e6;
    border-radius: 9px;
    margin-top: 20px;
  }

  .praise-box {
    width: 74px;
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 15px;
  }

  .praise-box img {
    width: 24px;
    vertical-align: text-bottom;
    margin-right: 4px;
  }

  .praise-box span {
    font-family: PingFangSC-Medium, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-size: 12px;
    font-weight: 500;
    color: #747c80;
  }

  .comment-box {
    display: flex;
    align-items: center;
    width: 74px;
    cursor: pointer;
    font-size: 15px;
  }

  .img-tag .img-tag-right img {
    width: 24px;
    vertical-align: text-bottom;
    margin-right: 4px;
  }

  .comment-box span {
    font-family: PingFangSC-Medium, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-size: 12px;
    font-weight: 500;
    color: #747c80;
  }

  .share__wrap {
    position: relative;
  }

  .share_box {
    display: flex;
    align-items: center;
    width: 74px;
    height: 100%;
    cursor: pointer;
  }

  .share__icon {
    display: inline-block;
    width: 24px;
    height: 24px;
    vertical-align: middle;
    transition: background .2s ease-in-out;
    background: url('~@/assets/circle/img14.png') 100% 100% no-repeat;
    background-size: 100%;
    margin-right: 4px;
  }

  .share__label {
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 500;
    color: #747c80;
    line-height: 16px;
  }

  .user-content-bottom {
    margin-left: 8px;
    text-align: left;
  }

  .user-content-bottom p:first-child {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 600;
    color: #18252c;
    line-height: 20px;
  }

  .user-content-bottom p:last-child {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 400;
    color: #9fa4a7;
    line-height: 17px;
    margin-top: 2px;
    cursor: auto;
    text-align: left;
  }

  .head-image-box img {
    height: 40px;
    width: 40px;
    border-radius: 50%;
  }

  /* 关注 */
  #follow-hover-btn-box {
    display: flex;
    margin-left: auto;
    margin-top: 6px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  #follow-hover-btn-box .follow-btn {
    width: 59px;
    height: 28px;
    background: oldlace;
    border-radius: 14px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 500;
    color: #FABE00;
    line-height: 28px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/view/Main/Post.vue